import { c as _c } from "react/compiler-runtime";
type EmailIconProps = {
  readonly className?: string;
};
export function EmailIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />;
    t2 = <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg aria-hidden="true" className={className} fill="currentColor" viewBox="0 0 24 24">{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}